import { Banknote, CheckCircle2, Clock3, FileSearch, Inbox, XCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { usePageHeader } from "../../components/shell/PageHeaderContext";
import { Spinner } from "../../components/Spinner";
import { formatMxn } from "../../lib/loans";
import { usePartnerOverview } from "../../lib/queries";

/** Queue at a glance for Peso a Peso: what is waiting, what was approved and how much. */
export function PartnerOverviewPage({ base }: { base: string }) {
  usePageHeader("Resumen", "Solicitudes de «Viaja ahora, paga después» enviadas desde Aventuria.");
  const overview = usePartnerOverview();
  if (overview.isLoading) return <div className="page-state"><Spinner label="Cargando" /></div>;
  if (overview.isError || !overview.data) {
    return <div className="page-state error"><strong>No pudimos cargar el resumen</strong><button className="secondary-button" onClick={() => void overview.refetch()}>Reintentar</button></div>;
  }
  const { byStatus, total, last30Days } = overview.data;
  const tiles = [
    { label: "Nuevas", value: String(byStatus.submitted.count), hint: `${formatMxn(byStatus.submitted.amount)} solicitados`, icon: Inbox, to: `${base}/solicitudes?estatus=submitted`, alert: byStatus.submitted.count > 0 },
    { label: "En revisión", value: String(byStatus.in_review.count), hint: `${formatMxn(byStatus.in_review.amount)} solicitados`, icon: Clock3, to: `${base}/solicitudes?estatus=in_review` },
    { label: "Aprobadas", value: String(byStatus.approved.count), hint: `${formatMxn(byStatus.approved.amount)} aprobados`, icon: CheckCircle2, to: `${base}/solicitudes?estatus=approved` },
    { label: "Rechazadas", value: String(byStatus.rejected.count), hint: `${formatMxn(byStatus.rejected.amount)} solicitados`, icon: XCircle, to: `${base}/solicitudes?estatus=rejected` },
    { label: "Monto aprobado", value: formatMxn(byStatus.approved.amount), hint: "Acumulado histórico", icon: Banknote },
    { label: "Total recibidas", value: String(total), hint: `${last30Days} en los últimos 30 días`, icon: FileSearch, to: `${base}/solicitudes` }
  ];
  return (
    <div className="page-container">
      <div className="stat-grid">
        {tiles.map(({ label, value, hint, icon: Icon, to, alert }) => {
          const body = (
            <>
              <span className={`benefit-icon${alert ? " alert" : ""}`}><Icon size={17} aria-hidden="true" /></span>
              <span className="stat-label">{label}</span>
              <strong translate="no">{value}</strong>
              <small>{hint}</small>
            </>
          );
          return to ? <Link key={label} className="stat-tile" to={to}>{body}</Link> : <div key={label} className="stat-tile">{body}</div>;
        })}
      </div>
      <section className="card">
        <div className="section-heading"><div><span className="page-eyebrow">Cómo funciona</span><h2>Revisar una solicitud</h2></div></div>
        <ol className="partner-howto">
          <li><strong>Abre la solicitud</strong> desde la lista. Verás el monto y plazo, la CURP completa, los datos de contacto y la constancia fiscal en PDF.</li>
          <li><strong>Márcala «En revisión»</strong> para que el resto del equipo sepa que la estás evaluando.</li>
          <li><strong>Registra la decisión</strong> — aprobada o rechazada — con una nota opcional. Aventuria avisa al solicitante por correo; las condiciones finales las comunica Peso a Peso directamente.</li>
        </ol>
        <p className="field-hint">Aventuria no otorga ni aprueba créditos: solo recibe la solicitud, resguarda la evidencia de la autorización y registra la decisión que Peso a Peso toma aquí.</p>
      </section>
    </div>
  );
}
